// @ts-nocheck
import styles from "./searchpay.module.scss";
import { useEffect, useState, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";
import { getOrderData } from "services/api";
import useUrlData from "store/DataStore";

const POLLING_INTERVAL = 5000;

const SearchPay = () => {
  const { t } = useTranslation();
  const { orderId } = useParams<{ orderId: string }>();
  const navigate = useNavigate();
  const { mapServerData, data } = useUrlData();

  const checkStatusAndRedirect = useCallback((status: string) => {
    const s = status.toLowerCase();
    if (s === 'expired') { navigate(`/canceled/${orderId}?type=expired`, { replace: true }); return true; }
    if (s === 'cancelled' || s === 'canceled') { navigate(`/canceled/${orderId}?type=canceled`, { replace: true }); return true; }
    if (s === 'completed' || s === 'finished' || s === 'success') { navigate(`/success/${orderId}`, { replace: true }); return true; }
    return false;
  }, [navigate, orderId]);

  useEffect(() => {
    if (!orderId || orderId === 'mock') return;
    const poll = async () => {
      try {
        const apiData = await getOrderData(orderId);
        mapServerData(apiData);
        if (apiData.state) checkStatusAndRedirect(apiData.state);
      } catch (e) { console.error(e); }
    };
    poll();
    const id = setInterval(poll, POLLING_INTERVAL);
    return () => clearInterval(id);
  }, [orderId, mapServerData, checkStatusAndRedirect]);

  const formatAmount = (amount: number) => amount?.toLocaleString('es-AR') || '0';

  return (
    <div className={styles.page}>
      <header className={styles.header}>
        <span className={styles.logo}>PagoPay</span>
        <span className={styles.step}>Verificando</span>
      </header>

      <div className={styles.content}>
        <div className={styles.loader}>
          <div className={styles.spinner} />
        </div>
        <div className={styles.title}>Verificando pago</div>
        <div className={styles.subtitle}>Esto puede tomar unos momentos</div>
        
        {data.amount > 0 && (
          <div className={styles.amountBox}>
            <span className={styles.amountLabel}>Monto</span>
            <span className={styles.amountValue}>$ {formatAmount(data.amount)}</span>
          </div>
        )}

        <div className={styles.warning}>
          No cierre esta página
        </div>
      </div>

      <footer className={styles.footer}>
        <span>ID: {orderId?.slice(0, 8)}</span>
      </footer>
    </div>
  );
};

export default SearchPay;
